import React, { Fragment } from 'react'
import { connect, useDispatch } from 'react-redux'

import ReactModal from 'react-modal'
import { translate } from 'react-i18next'
import { makeGetToken } from 'lib/selector'
import { setToast } from 'containers/client/actions'

import styled from 'styled-components'
import { ReactComponent as IconCloseFilter } from 'assets/img/icon/ic_close_filter.svg'

import ConfirmDelSignalModal from './confirmDelSignal'
import { handleApiErrors } from 'lib/api-errors'
import { analUserSignalRequest } from 'containers/market/actions'
import { arrMCStock, arrAvgVolStock } from 'utils/config'
import * as _ from 'lodash'
import PerfectScrollbar from 'react-perfect-scrollbar'
import Editcanhbao from './editcanhbao'

const apiUrl = `${process.env.REACT_APP_ALGO_API_URL}`

//#region
const customStyles = {
  content: {
    top: '40px',
    left: '50%',
    width: '556px',
    transform: 'translate(-50%)',
    bottom: 'auto',
    backgroundColor: 'var(--bg-th-even)',
    border: 'none',
    boxShadow: '0px 0px 3px rgba(160, 160, 160, 0.25)',
  },
}

const StyleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 0;
  background: ${(props) => (props.theme === 'dark' ? '#1c192c' : '#ffffff')};
  border-radius: 8px;
`

const StyleHeader = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  color: var(--half_white);
  font-weight: 500;
  font-size: 16px;
  padding: 16.5px 24px;
  border: 1px solid #4e4d62;
  border-width: 0 0 1px 0;
`

const StyleBody = styled.div`
  padding: 16px 24px;
`

const StyleContent = styled.div`
  background: #131021;
  border-radius: 8px;
  border: 1px solid #131021;

  &:hover {
    border-color: #f0b90b;
  }

  &:not(:last-of-type) {
    margin-bottom: 12px;
  }

  .content-header {
    display: flex;
    padding: 16px;
    border-bottom: 1px solid #312f43;
    color: #d7d6d9;
    font-size: 14px;
    line-height: 16px;

    span {
      font-weight: 700;
    }

    .group-action {
      font-weight: 400;
      display: flex;

      a {
        padding: 0 12px;

        &:first-of-type {
          border-right: 1px solid #4e4d62;
        }
        &:last-of-type {
          padding-right: 4px;
        }
      }
    }
  }

  .content-body {
    color: #d7d6d9;
    padding: 16px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;

    ul {
      li {
        padding: 6px;
        display: flex;
        justify-content: space-between;

        span:last-of-type {
          font-weight: 500;
        }
      }
    }
  }
`
//#endregion

function QuanLyCanhBao(props) {
  const abortController = new AbortController()
  const dispatch = useDispatch()
  const [showConfirm, setShowConfirm] = React.useState(null)
  const [signalEdit, setSignalEdit] = React.useState(null)
  const { token, onClose, t, signals, theme } = props

  React.useEffect(() => {
    return () => {
      abortController.abort()
    }
  }, [])

  function _handleToast(msg, type = 'info') {
    const toastMsg = {
      id: Math.random(),
      msg: msg,
      title: 'Thông báo',
      type,
    }
    dispatch(setToast(toastMsg))
  }

  function _handleDelSignal(record) {
    setShowConfirm(record)
  }

  function _handleAcceptDel() {
    fetch(
      apiUrl +
        'pbapi/api/usersignals/' +
        token?.user +
        '?signalId=' +
        showConfirm?.signalID,
      {
        method: 'DELETE',
        signal: abortController.signal,
      }
    )
      .then(handleApiErrors)
      .then((response) => response.json())
      .then((json) => {
        if (json.status === 200) {
          // setAllTier(json.data)
          _handleToast('Xóa tín hiệu thành công', 'success')
          setShowConfirm(null)
          dispatch(analUserSignalRequest(token?.user))
        } else {
          _handleToast(json.message, 'error')
        }
      })
      .catch((error) => {
        // throw error;
        _handleToast(error, 'error')
      })
  }

  return (
    <ReactModal
      isOpen={true}
      contentLabel="onRequestClose Example"
      onRequestClose={onClose}
      //   shouldCloseOnOverlayClick={true}
      style={customStyles}
    >
      <StyleContainer theme={theme}>
        <StyleHeader>
          {t('algo.cb.txt-Manage-signals')}
          <a className="ml-auto" onClick={onClose}>
            <IconCloseFilter />
          </a>
        </StyleHeader>
        <StyleBody>
          <PerfectScrollbar style={{ maxHeight: 'calc(100vh - 175px)' }}>
            {signals &&
              signals.map((item, index) => {
                const _seclist = item.secList ? item.secList.split(',') : []
                const _showList =
                  _seclist && _seclist.length > 3
                    ? _.take(_seclist, 3).join(', ') + '...'
                    : _seclist.join(', ')
                return (
                  <StyleContent key={index}>
                    <div className="content-header">
                      <span className="mr-auto">{item.signalName}</span>
                      <div className="group-action">
                        <a
                          className="txt-edit"
                          onClick={() => setSignalEdit(item)}
                        >
                          {t('algo.cb.txt-Edit')}
                        </a>
                        <a
                          className="txt-delete"
                          onClick={() => _handleDelSignal(item)}
                        >
                          {t('algo.cb.txt-Delete')}
                        </a>
                      </div>
                    </div>
                    <div className="content-body">
                      <ul>
                        <li>
                          <span>Loại tín hiệu:</span>
                          <span>
                            {t('algo.signal.' + item.realtimeFormulaID)}
                          </span>
                        </li>
                        <li>
                          <span>
                            {item.groupSecType == '3'
                              ? 'Sàn'
                              : 'Mã chứng khoán'}
                            :
                          </span>
                          <span>
                            {item.groupSecType == '3'
                              ? item.groupSecName
                              : _showList}
                          </span>
                        </li>
                        {item.mcFilter > 0 && (
                          <li>
                            <span>Vốn hóa:</span>
                            <span>
                              {
                                _.find(
                                  arrMCStock,
                                  (o) => o.value == item.mcFilter
                                )?.label
                              }
                            </span>
                          </li>
                        )}
                        {item.volFilter > 0 && (
                          <li>
                            <span>TB KLGD 5 phiên:</span>
                            <span>
                              {
                                _.find(
                                  arrAvgVolStock,
                                  (o) => o.value == item.volFilter
                                )?.label
                              }
                            </span>
                          </li>
                        )}
                      </ul>
                    </div>
                  </StyleContent>
                )
              })}
          </PerfectScrollbar>
          {/* <div className="d-flex justify-content-end mt-2">
            <StyleBtnSubmit type="button">Tạo cảnh báo</StyleBtnSubmit>
          </div> */}
        </StyleBody>
      </StyleContainer>
      {showConfirm && (
        <ConfirmDelSignalModal
          onClose={() => setShowConfirm(null)}
          onAccept={_handleAcceptDel}
        />
      )}

      {signalEdit && (
        <Editcanhbao
          theme={theme}
          onClose={() => setSignalEdit(null)}
          record={signalEdit}
        />
      )}
    </ReactModal>
  )
}

const makeMapStateToProps = () => {
  const getToken = makeGetToken()

  const mapStateToProps = (state) => {
    return {
      token: getToken(state),
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps)(
  translate('translations')(QuanLyCanhBao)
)
